import request from '@/utils/request'

export function getUserAccountInfo(data) {
    return request({
        url: '/api/common/v1/user/getUserAccountInfo',
        method: 'post',
        data
    })
}

export function getUserSpaceInfo(data) {
    return request({
        url: '/api/common/v1/user/getUserSpaceInfo',
        method: 'post',
        data
    })
}

export function setTenantIdApi(data) {
    return request({
        url: '/api/common/v1/tool/setTenantId',
        method: 'post',
        data
    })
}
